import { Link } from 'react-router';
import Button from 'react-bootstrap/Button';
import styled from 'styled-components';

import ProjectTags from '@components/projectComponents/projectTags/ProjectTagsWrapper';
import ProjectThumbnail from '@components/projectComponents/ProjectThumbnail';
import { CardTitle, CardDate } from '../ProjectCardComponents';
import { IMAGE_MODE } from '@utils/constants';

const Body = styled.div`
	padding: 1rem;
	${props => props.$error && 'background: var(--bs-danger-bg-subtle);'}
`;

const StyledCardDate = styled(CardDate)`
	margin-bottom: 2rem;
`;

const OverlayComponent = ({ projectData }) => {
	if (!projectData) return null;
	const { orthophoto_progress, uuid, tags, title, created_at, image_mode } = projectData;

	const error = !!orthophoto_progress?.error;
	const isVideoProject = image_mode === IMAGE_MODE.VIDEO;
	const projectPath = isVideoProject ? `/video-projects/${uuid}` : `/projects/${uuid}`;

	return (
		<>
			<ProjectTags uuid={uuid} tags={tags} />
			<ProjectThumbnail uuid={uuid} projectPath={projectPath} />
			<Body $error={error}>
				{error && (
					<p className="alert alert-danger small p-2">
						Project processing has failed
					</p>
				)}
				<CardTitle>{title}</CardTitle>
				<StyledCardDate created_at={created_at} />
				<Button as={Link} to={projectPath} variant="dark">
					View Project
				</Button>
			</Body>
		</>
	);
};
export default OverlayComponent;
